module.exports = __webpack_public_path__ + "img/imp_claw.67918e44.png";